<template>
  <v-btn size="x-small" v-on:click="dialog = true">
    <template v-slot:prepend>
      <v-icon :icon="['fas', 'floppy-disk']" />
    </template>
    {{ is_local ? 'ОБНОВИТЬ В 1С' : 'СОХРАНИТЬ В 1С' }}
  </v-btn>

  <v-dialog scrollable persistent v-model="dialog" width="500" style="backdrop-filter: blur(10px)">
    <v-card flat rounded="xl">
      <template v-slot:prepend>
        <v-btn
            :disabled="is_saving"
            block
            rounded="xl"
            color="grey-lighten-4"
            variant="flat"
            @click="dialog = false"
            v-on:contextmenu="ope_hidden"
            :icon="true"
        >
          <v-icon :icon="['fas', 'xmark']"/>
        </v-btn>
      </template>
      <template v-slot:title>
        <p class="text-center">СОХРАНЕНИЕ ОТЧЁТА</p>
        <p class="text-center">В БРАУЗЕРЕ</p>
      </template>
      <template v-slot:subtitle v-if="!hidden">
        <p class="text-center" style="font-size: 10px">{{ item_uuid }}</p>
      </template>
      <template v-slot:text>
        <v-text-field
            :disabled="is_saving"
            rounded="0"
            density="compact"
            flat
            hide-details
            label="Введите название отчёта"
            v-model="item_name"
        />
        <v-textarea
            :disabled="is_saving"
            rows="10"
            rounded="0"
            density="compact"
            flat
            hide-details
            class="mt-2"
            label="Комментарий к отчёту"
            v-model="item_desc"
        />
      </template>
      <template v-slot:actions>
        <v-sheet class="d-flex justify-center align-center flex-column" width="100%" color="transparent">
          <v-btn
              :disabled="is_saving"
              class="mb-1"
              block
              rounded="xl"
              :color="is_local ? 'grey-lighten-4' : 'green'"
              variant="flat"
              @click="save_into_database()"
          >
            <span v-if="is_local">СОХРАНИТЬ НОВЫЙ ЭКЗЕМПЛЯР</span>
            <span v-else>СОХРАНИТЬ</span>
          </v-btn>
          <v-btn
              :disabled="is_saving"
              block
              v-if="is_local"
              rounded="xl"
              color="green"
              variant="flat"
              @click="save_into_database(true)"
          >
            ПЕРЕЗАПИСАТЬ
          </v-btn>
        </v-sheet>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { ReportData } from "@/store/report/ReportData";
import { Allerts } from "@/store/global/Allerts";
import { Rep_Contract, Rep_Period } from "@/store/report/SmallStorrage";
import { UUID } from "@/libs/magic";
import {ItemData, ItemDesc, ItemName, ItemUUID, ListOfReports} from "@/store/report/save.store";
import {TokenGUIDStore} from "@/store/global/SessionStore";
export default {
  name: "SaveReportDialog",
  mounted() {
    this.update_report()
  },
  data() {
    return {
      is_saving: false,
      hidden: true,
      dialog: false
    }
  },
  methods: {
    ope_hidden: function () {
      event.preventDefault();
      this.hidden = !this.hidden

    },
    update_report: function () {
      this.item_uuid = this.item_uuid ? this.item_uuid : UUID()
      this.item_name = this.item_name ? this.item_name : this.default_name
      this.item_desc = this.item_desc ? this.item_desc : ""
    },
    get_reports_list: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/rm/reports`

      let properies = {
        method: 'GET',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения Документов!`
            }
          })
          .then(result => {
            this.list = result
          }).catch(err => {
            Allerts().warn('ОШИБКА', err, '#ff0000', 'triangle-exclamation')
            console.error(err)
          })
    },
    save_into_database: async function (can_overwrite = false) {
      this.is_saving = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/rm/report`
      let raw = {
        uuid: this.item_uuid,
        name: this.item_name,
        description: this.item_desc,
        line: JSON.stringify(this.report_data),
        date_start: this.range.start,
        date_end: this.range.end,
        contract: this.contract,
      }

      if (can_overwrite) {
        raw.can_overwrite = can_overwrite
      }

      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения Документов!`
            }
          })
          .then(async result => {
            await this.get_reports_list()
            this.item_data = result.line
            this.item_uuid = result.uuid
            this.item_name = result.name
            this.item_desc = result.description

            Allerts().warn(can_overwrite ? 'ОБНОВЛЕНО' : 'СОХРАНЕНО', `Файл успешно ${can_overwrite ? 'обновлён' : 'сохранён'}!`, 'light-green', 'floppy-disk')
            this.dialog = false

          }).catch(err => {
            Allerts().warn('ОШИБКА', err, '#ff0000', 'triangle-exclamation')
            console.error(err)
          }).finally(() => {
            this.is_saving = false
          })
    }
  },
  computed: {
    session_token() {
      return TokenGUIDStore().get()
    },
    is_local() {



      if (this.list && this.item_uuid) {
        if (this.list.findIndex(el => {
          if (el) {
            return el.uuid ===  this.item_uuid
          } else {
            return false
          }
        }) >= 0) {
          return true
        }
      }
      return false
    },
    list: {
      get() {
        return ListOfReports().get()
      },
      set(value) {
        ListOfReports().set(value)
      }
    },
    item_uuid: {
      get() {
        return ItemUUID().get()
      },
      set(value) {
        ItemUUID().set(value)
      }
    },
    item_name: {
      get() {
        return ItemName().get()
      },
      set(value) {
        ItemName().set(value)
      }
    },
    item_desc: {
      get() {
        return ItemDesc().get()
      },
      set(value) {
        ItemDesc().set(value)
      }
    },
    item_data: {
      get() {
        return ItemData().get()
      },
      set(value) {
        ItemData().set(value)
      }
    },
    range() {
      return Rep_Period().get()
    },
    report_data() {
      return ReportData().get()
    },
    contract() {
      return Rep_Contract().get()
    },
    default_name() {
      return `${this.report_data['Объект']} ${this.report_data.range.start} ${this.report_data.range.end}`
    }
  }
}
</script>

<style scoped>

</style>
